import React from 'react';
import _ from 'lodash';
import SelectizeWrapper from '../../selectize/SelectizeWrapper';
import '../../../../lib/widgets/tags/selectize-custom.scss';

const SelectFilter = ({
  query,
  tableId,
  columnKey,
  currentColumn,
  applyFilters,
  value,
  filterable = false
}) => {
  const formId = `form_${tableId}`;

  const selectOptions = () => (
    <React.Fragment>
      <option key="" value="">
        --Select below--
      </option>
      {currentColumn.select_values.map((option, idx) => {
        const value = Array.isArray(option) ? option[1] : option;
        const name = Array.isArray(option) ? option[0] : option;
        return (
          <option key={`${value}-${idx}`} value={value}>
            {name}
          </option>
        );
      })}
    </React.Fragment>
  );

  const selectOptionsSelectize = () => {
    const defaultOption = [{
      value: '',
      label: '--All--'
    }];

    return defaultOption.concat(
      currentColumn.select_values.map(option => {
        const value = Array.isArray(option) ? option[1] : option;
        const name = Array.isArray(option) ? option[0] : option;
        return {
          value: value,
          label: name
        }
      })
    );
  };

  if (currentColumn.type == 'filter') {
    if (!currentColumn.select_values) {
      throw new Error(
        `column ${currentColumn.label} is a filter but does not have any select_values.`
      );
    }

    if (filterable) {
      return (
        <SelectizeWrapper
          options={selectOptionsSelectize()}
          onChange={applyFilters}
          selectExtraProps={{
            form: formId,
            name: `filters[${columnKey}]`,
            defaultValue: query && query.filters && query.filters[columnKey],
            multiple: currentColumn.multiselect,
          }}
        />
      );
    }

    return (
      <select
        form={formId}
        onChange={applyFilters}
        name={`filters[${columnKey}]`}
        defaultValue={query && query.filters && query.filters[columnKey]}
        multiple={currentColumn.multiselect}
        className={`form-control filter-control select-pseudo steroid-filter ${currentColumn.multiselect ? 'selectpicker' : null}`}
      >
        { selectOptions() }
      </select>
    );
  } else if (currentColumn.datatype == 'date' || currentColumn.datatype == 'integer') {
    return (
      <select
        form={formId}
        onChange={e => {
          if (!_.isEmpty(value)) {
            applyFilters(e);
          }
        }}
        name={`search_operator_${columnKey}`}
        defaultValue={query[`search_operator_${columnKey}`]}
        className={
          'form-control filter-control select-pseudo steroid-filter table-on-steroid-form-operator'
        }
        style={{ minWidth: '4em' }}
        operator_value_field={`search_${columnKey}`}
        search_type="operator"
      >
        {currentColumn.datatype == 'date' &&
          Object.entries({ On: '=', Before: '<', After: '>' }).map(([k, v]) => (
            <option key={k} value={v}>
              {k}
            </option>
          ))}
        {currentColumn.datatype == 'integer' &&
          ['=', '<', '>'].map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
      </select>
    );
  }
};

export default SelectFilter;
